<div class="container-fluid" [dir]="language == 'ar' ? 'rtl' : 'ltr'">
  <div *ngFor="let comp of serviceCategories">
    <ng-container [ngSwitch]="comp.type">
      <div *ngSwitchCase="'app-service-hero'">
        <app-service-hero [data]="comp" [language]="language" [fileName]="'service-page/' + comp.fileName">
        </app-service-hero>
      </div>
      <div *ngSwitchCase="'text-with-image'">
        <app-text-with-image [data]="comp" [language]="language"
          [fileName]="'service-page/' + comp.fileName"></app-text-with-image>
      </div>
      <div *ngSwitchCase="'image-with-text'">
        <app-image-with-text [data]="comp" [language]="language"
          [fileName]="'service-page/' + comp.fileName"></app-image-with-text>
      </div>
      <div *ngSwitchCase="'app-service-card'">
        <app-service-card [data]="comp" [language]="language"
          [fileName]="'service-page/' + comp.fileName"></app-service-card>
      </div>
    </ng-container>
  </div>
</div>

<!-- <div class="process-follow">
  <app-process-follow></app-process-follow>
</div> -->